import React from 'react';

const MailIcon = (props) => (
  <svg
    width="24"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666748 4.59134L7.87566 8.38609C8.05783 8.48201 8.27566 8.48201 8.45783 8.38609L14.4637 5.22579C14.7139 5.29566 14.9777 5.33301 15.2501 5.33301C15.3918 5.33301 15.5312 5.3229 15.6675 5.30336L15.6667 10.958C15.6667 12.4022 14.5363 13.5823 13.1121 13.6621L12.9584 13.6663H3.37508C1.93089 13.6663 0.750706 12.5359 0.671031 11.1117L0.666748 10.958V4.59134ZM12.6142 1.16603C12.4342 1.54497 12.3334 1.96889 12.3334 2.41634C12.3334 3.22384 12.6616 3.95469 13.1917 4.48282L8.16675 7.12676L0.74604 3.22149C1.02612 2.09043 2.01701 1.23978 3.21736 1.17086L3.37508 1.16634L12.6142 1.16603ZM15.2501 0.333008C16.4007 0.333008 17.3334 1.26575 17.3334 2.41634C17.3334 3.56693 16.4007 4.49967 15.2501 4.49967C14.0995 4.49967 13.1667 3.56693 13.1667 2.41634C13.1667 1.26575 14.0995 0.333008 15.2501 0.333008Z"
      fill="#27B0E0"
    />
  </svg>
);
export default MailIcon;
